import React, { Fragment, useState, useEffect } from 'react';
import Back from 'components/main/Back';
import { View, Platform, StyleSheet } from 'react-native';
import Image from 'components/utility/CrossPlatformImage';
import { TouchableOpacity } from 'components/utility/Buttons';
import WhiteHamburger from 'resources/img/icons/hamburgerwhite.png';
import BlackHamburger from 'resources/img/icons/hamburger.png';
import { openSideBar } from 'reducers/slices/sidebar';
import { openControls } from 'reducers/slices/controls';
import HeaderContent from 'components/header/HeaderContent';
import SecondaryHeader from 'components/header/SecondaryHeader';
import { headerTitle } from 'utils/headerTitle';
import { Stack, Text, XStack, useTheme, SizableText } from 'tamagui';
import { Flex } from 'components/base/General';
import { useColorModeValue } from 'utils/hooks';
import { getCurrentPath } from 'utils/routing';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'solito/router';
import loadable from '@loadable/component';
import { SpeakerWirelessIcon } from 'app/components/utility/SVGIcons';
import { LinearGradient } from 'tamagui/linear-gradient';
import { useThemeName } from 'tamagui';

// TODO look at fontSize here between mobile and web
// TODO fix colors to reflect dark mode better
const HeaderTitle = ({
  children
}) => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(SizableText, {
    fontWeight: "bold",
    fontSize: "$xl"
    //my={0}
    ,
    color: theme.mainColor.get(),
    cursor: "pointer",
    style: {
      textTransform: 'uppercase'
    }
  }, children);
};
const VersionTitle = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(SizableText, {
    fontWeight: "bold",
    fontSize: "$xl",
    mb: 10,
    color: "white",
    cursor: "pointer",
    style: {
      textTransform: 'uppercase'
    }
  }, children);
};
const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject
    //backgroundColor: "rgba(201,0,0,0.45)",
  }
});
const SidebarHamburger = () => {
  const dispatch = useDispatch();
  const sidebar = useSelector(state => state.sidebar);
  const ColoredHamburger = useColorModeValue(BlackHamburger, WhiteHamburger);
  const toggleSidebar = () => {
    dispatch(openSideBar(!sidebar));
  };
  return /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: toggleSidebar
  }, /*#__PURE__*/React.createElement(Image, {
    source: ColoredHamburger,
    style: {
      height: 25,
      width: 25
    },
    alt: "Hamburger menu"
  }));
};
const FrontPage = () => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Stack, {
    bg: theme.background,
    zIndex: 900,
    px: 5,
    pb: 1
  }, /*#__PURE__*/React.createElement(XStack, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(SidebarHamburger, null), /*#__PURE__*/React.createElement(HeaderTitle, null, "Pandaist"), /*#__PURE__*/React.createElement(Stack, null)));
};
const WebFrontPage = () => {
  const colorMode = useThemeName();
  const theme = useTheme();
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
    return () => {
      setIsClient(false);
    };
  }, []);

  // TODO have to use this semi-hacky workaround as $theme-light and $theme-dark not always working

  return /*#__PURE__*/React.createElement(Stack, {
    bg: theme.background
  }, /*#__PURE__*/React.createElement(Stack, {
    mb: 20
  }, /*#__PURE__*/React.createElement(LinearGradient, {
    start: [0, 0],
    end: [1, 2.2],
    locations: [0, 1],
    colors: colorMode === 'dark' ? ['$pred800', '$pred600'] : ['$pred500', 'rgba(248, 139, 135, 0.8)'],
    style: styles.overlay
  }), isClient ? /*#__PURE__*/React.createElement(HeaderContent, null) : null, /*#__PURE__*/React.createElement(SecondaryHeader, null)));
};

// TODO analyze if necessary
const WebChildPage = () => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
    return () => {
      setIsClient(false);
    };
  }, []);
  const pathname = getCurrentPath();
  const setTitleWrapper = () => {
    let title = headerTitle(pathname);
    if (typeof title === 'undefined') {
      title = 'Pandaist';
    }
  };
  useEffect(() => {
    setTitleWrapper();
  }, []);
  useEffect(() => {
    setTitleWrapper();
  }, [pathname]);
  return /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    nativeID: "web-child-page"
  }, isClient ? /*#__PURE__*/React.createElement(HeaderContent, null) : null);
};
const TopChildPage = () => {
  const theme = useTheme();
  const pathname = getCurrentPath();
  const [title, setTitle] = useState('');
  const setTitleWrapper = () => {
    let title = headerTitle(pathname);
    setTitle(title);
  };
  useEffect(() => {
    setTitleWrapper();
  }, []);
  useEffect(() => {
    setTitleWrapper();
  }, [pathname]);
  return /*#__PURE__*/React.createElement(Stack, {
    bg: theme.background,
    px: 5,
    pb: 1
  }, /*#__PURE__*/React.createElement(XStack, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(SidebarHamburger, null), /*#__PURE__*/React.createElement(SizableText, {
    fontWeight: "bold",
    fontSize: "$lg",
    color: theme.mainColor.get(),
    style: {
      textTransform: 'uppercase'
    }
  }, title), /*#__PURE__*/React.createElement(Flex, null)));
};
const ArticlePage = () => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Stack, {
    bg: theme.background,
    px: 5,
    pb: 1
  }, /*#__PURE__*/React.createElement(XStack, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Back, null), /*#__PURE__*/React.createElement(Flex, null)));
};
const ChildPage = () => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Stack, {
    bg: theme.background,
    px: 5,
    pb: 1
  }, /*#__PURE__*/React.createElement(XStack, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Back, null)));
};
const HeaderToUrl = {
  frontPage: ['/', '/cards', '/index'],
  topChildPage: ['/quizzes', '/settings', '/dictionary'],
  childPage: ['/collection/[slug]', '/collection', '/support', '/error', '/about', '/wordlist', '/sentencelist', '/writing', '/statistics', '/flashcards', '/subscription', '/contact', '/writing', '/privacy', '/terms', '/blog', '/bookmarks', '/hanzi-match', '/cloze', '/memory-match', '/pinyin-match', '/chengyu', '/chengle', '/grammar', '/mw', '/pinyin-match', '/trad-simp', '/tone-match', '/hsk-charts', '/pinyin-chart'],
  articlePage: ['/article', '/article/[slug]'],
  emptyPage: ['/login']
};
const WebHeaderToUrl = {
  webfrontPage: ['/', '/cards'],
  webchildPage: ['/support', '/error', '/settings', '/about', '/contact', '/article', '/quizzes', '/login', '/admin', '/profile', '/writing-list', '/blogs', '/blog', '/dictionary'],
  webemptyPage: ['/privacy', '/terms', '/sitemap']
};
const EmptyPage = () => /*#__PURE__*/React.createElement(Fragment, null);
const HeaderComponents = {
  frontPage: FrontPage,
  topChildPage: TopChildPage,
  childPage: ChildPage,
  articlePage: ArticlePage,
  emptyPage: EmptyPage,
  webemptyPage: EmptyPage,
  webfrontPage: WebFrontPage,
  webchildPage: WebChildPage
};
const Header = () => {
  const theme = useTheme();
  const pathname = getCurrentPath();
  const getHeaderComponent = () => {
    let headerURLS = WebHeaderToUrl;
    if (Platform.OS !== 'web') {
      headerURLS = HeaderToUrl;
    }
    for (const headerType in headerURLS) {
      // TODO super hacky. You should change how the whole routing/navigation header thing works. Maybe templates?
      let newPath = pathname.split('/', 2).join('/');
      if (headerURLS[headerType].includes(newPath)) {
        const component = HeaderComponents[headerType];
        return component;
      }
    }
    if (Platform.OS !== 'web') {
      return ChildPage;
    } else if (Platform.OS === 'web') {
      return WebChildPage;
    }
  };
  const ComponentToRender = getHeaderComponent();
  return /*#__PURE__*/React.createElement(Stack, {
    bg: theme.sidebarGray.get()
  }, /*#__PURE__*/React.createElement(ComponentToRender, null));
};
export default Header;